import Vue from 'vue'
import Router from 'vue-router'
import qs from 'qs'
import store from '@/store'

import { isNumeric } from '@/utils/helpers'
import services from './services'

import Components from '@/components'

Vue.use(Router)

// eslint-disable-next-line
let router = {}

const routes = [
  {
    path: '/',
    name: 'Main',
    component: Components.Main,
    meta: {
      access: 'checkMainAccess',
      noContainer: true,
      noNavMargin: true
    }
  },
  {
    path: '/lk',
    name: 'Lk',
    component: Components.Lk,
    meta: {
      access: 'checkLkAccess'
    }
  },
  {
    path: '/cart/:service/:id',
    name: 'Cart',
    component: Components.Cart,
    meta: {
      access: 'checkCartAccess'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Components.Login,
    meta: {
      hideNavigation: true
    }
  },
  {
    path: '/orders/:orderId',
    name: 'Order',
    component: Components.Order,
    meta: {
      access: 'checkOrdersAccess'
    }
  },
  {
    path: '/orders',
    name: 'ListOrders',
    component: Components.ListOrders,
    meta: {
      access: 'checkOrdersAccess'
    }
  },
  {
    path: '/orders/payment/:paymentHash',
    name: 'Payment',
    component: Components.Payment,
  },
  {
    path: '/favorites',
    name: 'Favorites',
    component: Components.Favorites,
    meta: {
      access: 'checkFavoritesAccess'
    }
  },
  {
    path: '/sale',
    name: 'Sale',
    component: Components.Sale,
    meta: {
      access: 'checkSaleAccess'
    }
  },
  {
    path: '/my-agency',
    name: 'MyAgency',
    component: Components.MyAgency,
    meta: {
      requiresAuth: true
    },
  },
  ...services,
  {
    path: '/events',
    name: 'Events',
    component: Components.Events,
    meta: {
      access: 'checkEventsAccess'
    }
  },
  {
    path: '/contacts',
    redirect: {
      name: 'Contacts',
      params: {
        slug: 'moscow'
      }
    },
  },
  {
    path: '/contacts/:slug',
    name: 'Contacts',
    component: Components.Contacts
  },
  {
    path: '/fatal-error',
    name: 'FatalError',
    component: Components.FatalError,
  },
  {
    path: '/not-found',
    name: 'NotFound',
    component: Components.NotFound,
  },
  {
    path: '/access-denied',
    name: 'AccessDenied',
    component: Components.AccessDenied,
  },
  {
    path: '*',
    redirect: { name: 'NotFound' },
    name: 'NotFoundHandler',
    component: Components.NotFound,
  }
]

router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkExactActiveClass: 'active',
  linkActiveClass: 'root-active',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 100)
    })
  },
  parseQuery: query => qs.parse(query, {
    decoder: str => (isNumeric(str) ? parseFloat(str) : str)
  }),
  stringifyQuery(query) {
    const result = qs.stringify(query, { encode: false })

    return result ? `?${result}` : ''
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.access)) {
    const accessGetterName = to.matched[0].meta.access

    if (store.getters[`account/${accessGetterName}`]) {
      next()
    } else {
      next({ name: 'AccessDenied' })
    }
  } else {
    next()
  }
})

export default router
